import { BoxV2 as Box, SxProps } from 'portal-commons';
import React from 'react';

interface Props {
  title?: string;
  sx?: SxProps;
}

const CroppableItem: React.FC<Props> = ({ title, sx, children }) => (
  <Box
    title={title}
    sx={{
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default CroppableItem;
